import React, {useEffect,useState} from 'react';
import styles from './YaPagadosView.module.scss';
import Heading from "common/components/Typography/Heading/Heading";
import { useDispatch } from "react-redux";
import { retrieveCatalogs } from "modules/bussiness_logic/actions/catalogActions";
import DataTableWidget from "common/components/DataTableWidget/DataTableWidget";
import Axios from 'services/BackendApi/BackendApi';
import { useNavigate,Link } from "react-router-dom";
import {Button, Form} from 'react-bootstrap';
import FormElement from 'common/components/FormElement/FormElement';

export default function YaPagadosView(props){
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [tableData, setTableData] = useState({loading:true,data:[]});
    const [formData,setFormData] = useState({validSearch: false, status:0,data:{"proveedor_id":"",value:""}});
    const [viewError,setViewError] = useState({display:false, message:''});
    const [viewTitle,setViewTitle] = useState({text:"Trámites ya pagados"});
    function switchDossierTypeLabel(typelbl){
      switch (typelbl){
        case 1:{return "Facturas en papel";}break;
        case 2:{return "Facturas electrónicas";}break;
        case 3:{return "Recibos/Invoices en papel";}break;

      }
    }
   
    const columns = [
       
      {
        name: <span className={styles.tableheader}>Recibido en</span>,
        selector: (row) => <Link  className={styles.tablelink}  to={'/detalle-tramite/'+row.id}>{row.fecha_registro}</Link>,
        sortable: true,
        right: false,
        compact: true,
        maxWidth: '130px'
      },
      {
        name: <span className={styles.tableheader}>Tipo</span>,
        selector: (row) => <Link  className={styles.tablelink} to={'/detalle-tramite/'+row.id}>{row.type_label}</Link>,
        sortable: true,
        compact: true
      },
      {
        name: <span className={styles.tableheader}>ESTATUS</span>,
        selector: (row) => {return <Link  className={styles.tablelink+" "+styles.recibidovent} to={'/detalle-tramite/'+row.id}>{row.status_label}</Link>; },

        sortable: true,
        right: false,
        compact: true
      },
      {
        button: true,
        cell: (row) => {
            //console.log(row);
            return <div>
                <Button variant="primary" onClick={()=>{navigate('/detalle-tramite/'+row.id);}}>Ver</Button>  
            </div>;
          }
        
      }
      ];

      async function processTxFiltered(){
        let dossiers = [];
        
        try {
            
            const {data}=  await  Axios.SearchTramiteByDocumentId({
                'proveedor_id':'',
                'valor': formData.data.value
            });

            
          
            if (data.error){
               //console.log('Error,',data);
            }
            
            if (data.result && !data.error==1){
               //console.log('Good',data);

               if (data.freeSQL_result.result.length>0){

                if (!data.freeSQL_result.result[0].error){
                  setTableData({loading:true,data:[]});
                data.freeSQL_result.result.map((item,idx)=>{
                  dossiers[dossiers.length]={...item,data: JSON.parse(item.data)};
                  //dossiers[dossiers.length-1].files = data.query_result[1].result.filter((oneD) => oneD.dossier ==item.dossier);
                })
                setViewTitle({text: "Resultado de búsqueda ("+(data.freeSQL_result.result.length).toString()+" coincidencias)"});
                //console.log('json interpreted',dossiers);
                setTableData(
                  {
                    loading:false,
                    data:{
                        dossiers: dossiers
                    }
                  }
                );
              }else{
                setViewError({display:true,message:data.freeSQL_result.result[0].error_log});
              }
              }else{
                setViewError({display:true,message:'No se encontraron resultados con ese identificador'});
              }
               //console.log("this was stored",tableData);
            }	else{
              setViewError({display:true,message:'No se encontraron resultados con ese identificador'});
            }
         }catch(error){
             console.log('catch Error',error);
         }
    }
    
    async function processTx(){
        let dossiers = [];
        setTableData({loading:true,data:[]});
        try {
            
            const {data}=  await  Axios.ListarMyTramitesYaPagados();//Axios.ListarMyTramites();

            
            if (data.error){
               //console.log('Error,',data);
            }
            if (data.result && !data.error){
               //console.log('Good',data);
               data.query_result[0].result.map((item,idx)=>{
                
                 dossiers[dossiers.length]={...item,data: JSON.parse(item.data)};
                 dossiers[dossiers.length-1].files = data.query_result[1].result.filter((oneD) => oneD.dossier ==item.dossier);
               })
               //console.log('json interpreted',dossiers);
               setTableData(
                 {
                   loading:false,
                   data:{
                       dossiers: dossiers
                   }
                 }
               );
               //console.log("this was stored",tableData);
            }	
         }catch(error){
             console.log('catch Error',error);
         }
    }
    useEffect(()=>{
        dispatch(retrieveCatalogs());
        processTx();
    },[dispatch]);
    function handleSelectedItems(rows){
      //console.log('The rows are>',rows);
      //setConfirmLot({dialog:false, data: rows.selectedRows});
    }
    function handleSearchChange(evc){
      if (evc.target.value===""){
        setViewTitle({text:"Trámites ya pagados"});
        setViewError({display:false,message:''});
        processTx();
      }
      setFormData({validSearch: (formData.data.value.length>=1), status:0,data:{"proveedor_id":"2519724k",value:evc.target.value}});
    }
    function submitHandler(evs){
      evs.preventDefault();
      if (formData.validSearch===true) processTxFiltered();
    }
    return <div className={styles.scrollmessage}>
                    <Heading variant="h2">Trámites ya pagados</Heading>
                    <div>
                      <Form onSubmit={submitHandler}>
                        <FormElement 
                          type="search" 
                          label="Búscar por número de documento" 
                          id="value_busqueda" name="value_busqueda" 
                          value={formData.data.value} fieldLength={4}  onChange={handleSearchChange} onKey error={viewError.display}
                          errorMessage={viewError.message}
                          onSearchButtonClick={(evc)=>{
                            processTxFiltered()
                          }}     
                                    >
                                      
                                       </FormElement>
                      </Form>
                    </div>
                    { (tableData.loading===true)? "Cargando...":
                      <DataTableWidget
                        title={viewTitle.text}
                        columns={columns}
                        data={tableData.data.dossiers}
                        handleSelection={handleSelectedItems}
                        selectableRowDisabled={row => (true)}
                      />
                    }
        </div>;
}